/**
 * The single localStorage key the dashboard reads to learn today's rotating API host. Written by
 * the PWA (the ONLY place discovery runs) and consumed same-origin by the dashboard at `/app`.
 */
export const API_DOMAIN_STORAGE_KEY = 'vn-pwa:api-domain'

/**
 * Resolve `localStorage`, never throwing. In the target sandboxed in-app/WebView browsers even
 * *reading* `window.localStorage` can raise a SecurityError — and because default parameters are
 * evaluated at the call site before the callee's own try/catch runs, that read must be guarded
 * here rather than left as a bare default value.
 */
const resolveStorage = (): Pick<Storage, 'setItem'> | undefined => {
  try {
    return localStorage
  } catch {
    return undefined
  }
}

/**
 * Persist the adopted, signature-verified API domain so the same-origin dashboard can resolve its
 * backend host synchronously at boot. Never throws — not even via its default parameter: in a
 * sandboxed in-app/WebView browser both reading and writing `localStorage` can raise, and a
 * failed persist is recoverable — the dashboard will bounce back and the PWA re-discovers — so a
 * throw here must not tear down a successful boot.
 */
export const persistApiDomain = (
  domain: string,
  storage: Pick<Storage, 'setItem'> | undefined = resolveStorage(),
): void => {
  try {
    storage?.setItem(API_DOMAIN_STORAGE_KEY, domain)
  } catch {
    // Storage blocked; the dashboard's re-discovery path is the fallback.
  }
}
